import React, { createContext, useState } from "react";

const AccountContext = createContext();

const AccountProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [fetchByAccountId, setFetchByAccountId] = useState(0);
  const [fetchBrandByAccountId, setFetchBrandByAccountId] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [accountType, setAccountType] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [accountViewRefresh, setAccountViewRefresh] = useState(false);
  const [country, setCountry] = useState("IN");
  const [breadCrumbName, setBreadCrumbName] = useState(
    <span className="cursor-default" style={{ color: "#333333" }}>
      Account
    </span>
  );
  const [showInvoiceStepperForSales, setShowInvoiceStepperForSales] =
    useState(false);
  const [accountStepper, setAccountStepper] = useState({
    information: false,
    financials: false,
    configuration: false,
    access: false,
    invoice: false,
  });
  // JSON Data

  const createNewAccount = () => {
    setFetchByAccountId(0);
    setIsEditing(false);
    setAccountType(0);
    setActiveStep(0);
    setCountry("IN");
    setBreadCrumbName(
      <span className="cursor-default" style={{ color: "#333333" }}>
        Account
      </span>
    );
  };

  const resetFormData = () => {
    setFetchBrandByAccountId(0);
    setIsEditing(true);
    setAccountStepper({
      information: false,
      financials: false,
      configuration: false,
      access: false,
      invoice: false,
    });
  };

  return (
    <AccountContext.Provider
      value={{
        show,
        setShow,
        fetchByAccountId,
        setFetchByAccountId,
        fetchBrandByAccountId,
        setFetchBrandByAccountId,
        activeStep,
        setActiveStep,
        resetFormData,
        setIsEditing,
        isEditing,
        accountType,
        setAccountType,
        createNewAccount,
        accountViewRefresh,
        setAccountViewRefresh,
        country,
        setCountry,
        accountStepper,
        setAccountStepper,
        breadCrumbName,
        setBreadCrumbName,
        showInvoiceStepperForSales,
        setShowInvoiceStepperForSales,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};

export { AccountContext, AccountProvider };
